// src/context/StepContext.tsx

import { createContext, useContext, useState } from 'react';

type StepContextType = {
  step: number;
  setStep: (step: number) => void;
};

const StepContext = createContext<StepContextType | null>(null);

export const StepProvider = ({ children }: { children: React.ReactNode }) => {
  const [step, setStep] = useState(1);

  return <StepContext.Provider value={{ step, setStep }}>{children}</StepContext.Provider>;
};

export const useStep = () => {
  const context = useContext(StepContext);
  if (!context) throw new Error('useStep must be used inside StepProvider');
  return context;
};
